export const thunkStatus = {
    INIT: "init",
    PENDING: "pending",
    FULFILLED: "fulfilled",
    REJECT: "reject",
}